import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { durationBeginInvestmentOption } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'additional-question-investment',
    templateUrl: './additional-question-investment.component.html',
    styleUrls: ['./additional-question-investment.component.scss'],
    standalone: false
})
export class AdditionalQuestionInvestmentComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  durationBeginInvestmentOption = durationBeginInvestmentOption;
  constructor(
    protected formConstructor: PrFormConstructor,

    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();

    this.subscriptionFacade.submitPledge(this, 'accountInformations');
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
